import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollCreateCustomFieldRequest, PayrollCustomFieldDefinitionResponse } from '../types';

export const createCustomFieldMutation = gql`
  mutation PayrollCreateCustomField($input: PayrollCreateCustomFieldInput!) {
    payrollCreateCustomField(input: $input) {
      id
      fieldKey
      label
      valueType
      origin
      isRequired
      enumValues
      usages
      section
      displayOrder
      accessPolicy
    }
  }
`;

export const createCustomField = (queryVariables: PayrollCreateCustomFieldRequest) =>
  graphQLApi<PayrollCustomFieldDefinitionResponse<'payrollCreateCustomField'>, PayrollCreateCustomFieldRequest>({
    query: createCustomFieldMutation,
    queryVariables,
  });
